import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type DealerIntegrationDetailsFragmentFragment = (
  { __typename: 'DealerIntegrationDetails' }
  & Pick<SchemaTypes.DealerIntegrationDetails, 'dealerCode' | 'partnerNumber' | 'assortment'>
  & { autoplay?: SchemaTypes.Maybe<(
    { __typename: 'DealerAutoplay' }
    & Pick<SchemaTypes.DealerAutoplay, 'dealerId' | 'yardId'>
  )>, additionalParameter: Array<(
    { __typename: 'AdditionalIntegrationParameter' }
    & Pick<SchemaTypes.AdditionalIntegrationParameter, 'purpose' | 'value'>
  )> }
);

export const DealerIntegrationDetailsFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerIntegrationDetailsFragment on DealerIntegrationDetails {
  dealerCode
  partnerNumber
  assortment
  autoplay {
    dealerId
    yardId
  }
  additionalParameter {
    purpose
    value
  }
}
    `;